import { render, staticRenderFns } from "./MoviesLearning.vue?vue&type=template&id=8632955e&scoped=true&"
import script from "./MoviesLearning.vue?vue&type=script&lang=js&"
export * from "./MoviesLearning.vue?vue&type=script&lang=js&"
import style0 from "./MoviesLearning.vue?vue&type=style&index=0&id=8632955e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8632955e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
